document.addEventListener("DOMContentLoaded", (event) => {

const galleryRow = document.querySelector('.gallery-row.top-row');
if (galleryRow) {
  const elements = Array.from(galleryRow.children);

  // Перемешивание элементов
  elements.sort(() => Math.random() - 0.5);

  // Очистка контейнера и вставка перемешанных элементов
  galleryRow.innerHTML = '';
  elements.forEach(element => galleryRow.appendChild(element));
}


        const listMenus = document.querySelectorAll('.list-menu.list-menu--inline');
      
        listMenus.forEach(listMenu => {
          const menuItems = listMenu.querySelectorAll('details');
      
          menuItems.forEach(menuItem => {
            const summary = menuItem.querySelector('summary');
            const icon = summary.querySelector('.icon-caret');
            const content = menuItem.nextElementSibling;
      
            summary.addEventListener('click', (event) => {
              event.preventDefault();
      
              if (content.classList.contains('open')) {
                closeMenu(content, icon);
              } else {
                closeAllMenus(menuItems);
                openMenu(content, icon);
              }
            });
          });
      
          function closeAllMenus(menuItems) {
            menuItems.forEach(menuItem => {
              const content = menuItem.nextElementSibling;
              const icon = menuItem.querySelector('summary .icon-caret');
              closeMenu(content, icon);
            });
          }
      
          function openMenu(content, icon) {
            const summary = icon.closest('summary');
            content.classList.add('open');
            icon.classList.add('open');
            summary.classList.add('open-wrapper');
            content.style.maxHeight = content.scrollHeight + 'px';
          }
          
          function closeMenu(content, icon) {
            const summary = icon.closest('summary');
            content.classList.remove('open');
            icon.classList.remove('open');
            summary.classList.remove('open-wrapper');
            content.style.maxHeight = '0';
          }
        });

      
        const closeButtons = document.querySelectorAll('.menu-drawer__close-button');

        if (closeButtons.length > 0) {
          closeButtons.forEach(button => {
            button.addEventListener('click', (event) => {
              const parentDetails = button.closest('details');
              if (parentDetails && parentDetails.hasAttribute('open')) {
                parentDetails.removeAttribute('open');
                const content = parentDetails.querySelector('.mega-menu__content');
                const icon = parentDetails.querySelector('summary .icon-caret');
                if (content && icon) {
                  closeMenu(content, icon);
                }
              }
            });
          });
        }
      
        function closeMenu(content, icon) {
          content.classList.remove('open');
          icon.classList.remove('open');
          content.style.maxHeight = '0';
        }
      




    if ($('.banner-slider').length) {
        $('.banner-slider').slick({
            dots: false,
            infinite: true,
            speed: 500,
            arrows: false,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 3000,
          });
    }
    
    if ($('.gd-slider-for').length){
        $('.gd-slider-for').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 300,
            centerMode: true,
            asNavFor: '.gd-slider-nav',
            responsive: [
              {
                  breakpoint: 600,
                  settings: {
                      slidesToShow: 1,
                      centerMode: true,
                      centerPadding: '15%'
                  }
              }
          ]
        });
        $('.gd-slider-nav').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            asNavFor: '.gd-slider-for',
            dots: false,
            fade: true,
            focusOnSelect: true,
            nextArrow: '<svg width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Frame 1538230639"><path id="Vector" d="M23.6702 10L43 21.0827L23.6702 32L24.7393 26.4356L13 26.4356L13 15.5221L24.7468 15.5221L23.6702 10Z" fill="#D93400"/></g></svg>',
            prevArrow: '<svg width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Frame 1538230634"><path id="Vector" d="M32.3298 10L13 21.0827L32.3298 32L31.2607 26.4356L43 26.4356L43 15.5221L31.2532 15.5221L32.3298 10Z" fill="#D93400"/></g></svg>'
        });


        function addCustomStylesToActiveSlides() {
            $('.gd-slider-for img').removeClass('gd-style-1');
            $('.gd-slider-for img').removeClass('gd-style-2');
            $('.gd-slider-for img').removeClass('gd-style-3');
        
            $('.gd-slider-for .slick-active').each(function(index) {
              if (index === 0) {
                $(this).find('img').addClass('gd-style-1');
              } else if (index === 1) {
                $(this).find('img').addClass('gd-style-2');
              } else if (index === 2) {
                $(this).find('img').addClass('gd-style-3');
              }
            });
          }
          addCustomStylesToActiveSlides();
          $('.gd-slider-for').on('afterChange', function(event, slick, currentSlide, nextSlide) {

            addCustomStylesToActiveSlides();
          });
    }
      
    if ($('.steps-container').length){
        function initializeSlick() {
          $('.steps-container').slick({
              dots: true,
              infinite: false,
              speed: 300,
              slidesToShow: 4,
              slidesToScroll: 4,
              responsive: [
                  {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1
                      }
                  }
              ]
          });
      }

      function checkWidthAndToggleSlick() {
          if ($(window).width() <= 768) {
              if (!$('.steps-container').hasClass('slick-initialized')) {
                  initializeSlick();
              }
          } else {
              if ($('.steps-container').hasClass('slick-initialized')) {
                  $('.steps-container').slick('unslick');
              }
            }
        }

        checkWidthAndToggleSlick();

        $(window).resize(function() {
            checkWidthAndToggleSlick();
        });
    }
    // var BODY = document.querySelector('body');
    // BODY.addEventListener('scroll', function() {
    //   const paralax = document.querySelector('.parallax-block');
    //   let windowHeight = document.body.scrollHeight;

    //     const scrollPositionparalax = document.body.scrollTop;
    //     const documentHeightparalax = window.innerHeight;
    //     const pixelsToBottomparalax = windowHeight - (scrollPositionparalax + documentHeightparalax);

    //     paralax.style.transform = `matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -${pixelsToBottomparalax/2}, 0, 1)`
    // });

    // jQuery.scrollSpeed(100, 1500, 'easeOutCubic');
    // let isScrolling;
    // let targetScrollPosition = window.pageYOffset;
    // let isButtonClicked = false;
    // let isAnimating = false;
    
    // function easeOutQuad(t) {
    //     return t * (2 - t);
    // }
    
    // function smoothScroll(newScrollPosition, duration) {
    //     const startScrollPosition = window.pageYOffset;
    //     const distance = newScrollPosition - startScrollPosition;
    //     let startTime = null;
    
    //     function animation(currentTime) {
    //         if (startTime === null) startTime = currentTime;
    //         const timeElapsed = currentTime - startTime;
    //         const run = easeOutQuad(timeElapsed / duration) * distance + startScrollPosition;
    //         window.scrollTo(0, run);
    //         if (timeElapsed < duration) {
    //             requestAnimationFrame(animation);
    //         } else {
    //             isAnimating = false;
    //         }
    //     }
    
    //     isAnimating = true;
    //     requestAnimationFrame(animation);
    // }
    
    // document.getElementById('scrollToTopBtn').addEventListener('click', function () {
    //     isButtonClicked = true;
    //     targetScrollPosition = 0;
    //     smoothScroll(0, 800);
    // });
    
    // window.addEventListener('wheel', function (event) {
    //     if (isScrolling) {
    //         clearTimeout(isScrolling);
    //     }
    
    //     if (isButtonClicked) {
    //         isButtonClicked = false;
    //         targetScrollPosition = window.pageYOffset;
    //     }
    
    //     targetScrollPosition += event.deltaY;
    //     const maxScrollPosition = document.body.scrollHeight - window.innerHeight;
    //     targetScrollPosition = Math.max(0, Math.min(maxScrollPosition, targetScrollPosition));
    
    //     if (!isAnimating) {
    //         smoothScroll(targetScrollPosition, 800);
    //     } else {
    //         isScrolling = setTimeout(() => {
    //             smoothScroll(targetScrollPosition, 800);
    //         }, 50);
    //     }
    
    //     event.preventDefault();
    // }, { passive: false });
    
    //  Fix product btn  

        
    document.getElementById('scrollToTopBtn').addEventListener('click', function () {
        document.body.scrollTo({ top: 0, behavior: "smooth" });
    });

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    };

    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                if (entry.target.classList.contains('gallery-init')) {
                    gallery();
                }
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);


    const elementsToWatch = document.querySelectorAll('.watch-for-visibility');
    elementsToWatch.forEach(element => observer.observe(element));

    const quantityElement = document.querySelector('.product__info-wrapper .product-form__input.product-form__quantity');
    const fixedProductForm = document.querySelector('.fixed-product-form');

    if (quantityElement && fixedProductForm) {
        const productObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    fixedProductForm.classList.add('open');
                } else {
                    fixedProductForm.classList.remove('open');
                }
            });
        }, { threshold: 0 });

        productObserver.observe(quantityElement);
    }


    function gallery() {  
        setTimeout(() => {
        const galleryContainer = document.querySelector('.gallery-container');
        const sliderContainer = document.querySelector('.gallery-slider-container');
    
        galleryContainer.classList.add('fade-out');
    
        setTimeout(() => {
          galleryContainer.style.display = 'none';
          sliderContainer.classList.add('active');


          $('.gallery-slider').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            initialSlide: 0,
            centerMode: true,
            focusOnSelect: true,
            asNavFor: '.gallery-slider-nav, .gallery-slider-nav-2',
            responsive: [
              {
                  breakpoint: 600,
                  settings: {
                      slidesToShow: 1,
                      centerMode: true,
                      adaptiveHeight: true,
                      centerPadding: '30px'
                  }
              }
            ]
          });

          $('.gallery-slider-nav').slick({
              slidesToShow: 9,
              slidesToScroll: 9,
              initialSlide: 0,
              infinite: false,
              arrows: false,
              focusOnSelect: true,
              asNavFor: '.gallery-slider-nav-2, .gallery-slider',
              responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        centerPadding: '30px'
                    }
                }
              ]
          });
          $('.gallery-slider-nav-2').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              arrows: true,
              focusOnSelect: true,
              asNavFor: '.gallery-slider-nav, .gallery-slider',
              nextArrow: '<svg width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Frame 1538230639"><path id="Vector" d="M23.6702 10L43 21.0827L23.6702 32L24.7393 26.4356L13 26.4356L13 15.5221L24.7468 15.5221L23.6702 10Z" fill="#D93400"/></g></svg>',
              prevArrow: '<svg class="left-arr"  width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Frame 1538230634"><path id="Vector" d="M32.3298 10L13 21.0827L32.3298 32L31.2607 26.4356L43 26.4356L43 15.5221L31.2532 15.5221L32.3298 10Z" fill="#D93400"/></g></svg>'
          });
        }, 500);
      }, 4000);
    }
    

    if ( $('.restaraunt-gallery').length > 0) {
        
        const slider = $('.reastaraunt-gallery-slider');
        const thumbs = $('.reastaraunt-gallery-thumb');
    
        function initializeSlider() {
            slider.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                arrows: true,
                asNavFor: '.reastaraunt-gallery-thumb',
                nextArrow: '<svg width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Frame 1538230639"><path id="Vector" d="M23.6702 10L43 21.0827L23.6702 32L24.7393 26.4356L13 26.4356L13 15.5221L24.7468 15.5221L23.6702 10Z" fill="#D93400"/></g></svg>',
                prevArrow: '<svg class="left-arr"  width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Frame 1538230634"><path id="Vector" d="M32.3298 10L13 21.0827L32.3298 32L31.2607 26.4356L43 26.4356L43 15.5221L31.2532 15.5221L32.3298 10Z" fill="#D93400"/></g></svg>',

            });
    
            const containerWidth = thumbs.width();
            const slideWidth = 60;
            const slidesToShow = Math.max(1, Math.floor(containerWidth / slideWidth) - 2);
            console.log(slidesToShow)

            thumbs.slick({
                dots: false,
                speed: 300,
                slidesToShow: slidesToShow,
                slidesToScroll: slidesToShow,
                variableWidth: true,
                arrows: false,
                focusOnSelect: true,
                asNavFor: '.reastaraunt-gallery-slider',
            });
        }
    
        initializeSlider();
    

        // window.addEventListener('resize', function() {
        //     thumbs.slick('unslick');
        //     initializeSlider();
        // });
    

        // function isThumbVisible(index) {
        //     const visibleSlides = thumbs.find('.slick-slide.slick-active');
        //     let visible = false;
        //     visibleSlides.each(function() {
        //         if ($(this).data('slick-index') === index) {
        //             visible = true;
        //             return false;
        //         }
        //     });
        //     return visible;
        // }

        // slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        //     const targetThumbIndex = nextSlide;
        //     if (!isThumbVisible(targetThumbIndex)) {
        //         thumbs.slick('slickGoTo', targetThumbIndex);
        //     }
        // });


        // thumbs.on('click', '.slick-slide', function(event) {
        //     const index = $(this).data('slick-index');
        //     slider.slick('slickGoTo', index);

        //     if (!isThumbVisible(index)) {
        //         thumbs.slick('slickGoTo', index);
        //     }
        // });
    }


    if ($('.anchor-links').length > 0) {
        const anchorBlocks = document.querySelectorAll('.anchor-block');
        const anchorLinksContainer = document.querySelector('.anchor-links');

        anchorBlocks.forEach(block => {
            const anchorName = block.getAttribute('data-aname');
            const blockId = block.id;

            if (anchorName && blockId) {
            const anchorLink = document.createElement('a');
            anchorLink.classList = 'border-anim';
            anchorLink.href = `#${blockId}`;
            anchorLink.innerText = anchorName;
            
            anchorLinksContainer.appendChild(anchorLink);

            const offsetElement = document.createElement('div');
            offsetElement.id = `${blockId}-offset`;
            offsetElement.classList.add('anchor-link');
            block.parentNode.insertBefore(offsetElement, block);
            }
        });


        document.querySelectorAll('.anchor-links a').forEach(link => {
            link.addEventListener('click', function(event) {
            event.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            console.log(targetElement)
            if (targetElement) {
                
                document.body.scrollTo({
                top: targetElement.offsetTop - 100,
                behavior: 'smooth'
                });
            }
            });
        });
    }

    if($('.nav-menu-mob').length) {
        $('.nav-menu-mob').on('click',function(){
            if ($('.nav-menu-mob').hasClass('open')){
                $('.nav-menu-mob').removeClass('open')
            } else {
                $('.nav-menu-mob').addClass('open')
            }
            $('.navigation-menu').toggle();
        })
    }
});